import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CancelGenerationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-background/80 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-card rounded-xl border border-border p-6 md:p-8 max-w-md w-full animate-scale-in shadow-2xl">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-warning/10 flex items-center justify-center flex-shrink-0">
            <Icon name="AlertTriangle" size={24} className="text-warning" />
          </div>
          <div>
            <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
              Cancel Generation?
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              Are you sure you want to cancel the project generation? All progress will be lost and cannot be recovered.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            fullWidth
            onClick={onClose}
            className="order-2 sm:order-1"
          >
            Continue Generation
          </Button>
          <Button
            variant="destructive"
            fullWidth
            iconName="X"
            iconPosition="left"
            onClick={onConfirm}
            className="order-1 sm:order-2"
          >
            Cancel Generation
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CancelGenerationModal;